import React from "react";
import { showCustomToast } from "./Misc/CustomToast";

export default function StatusRibon(props) {
  const isPhilippinesRehab =
    props.rehabId === "miracles_asia_philippines" ||
    props.rehabCountry === "Philippines";
  const inHouseLabel = isPhilippinesRehab ? "Active" : "In House";

  const handleClick = () => {
    if (!props.isAllPreadmissionFieldsFilled) {
      showCustomToast(
        "All preadmission fields must be filled before changing the status.",
        "error"
      );
      return;
    }
    if (props.onClick) {
      props.onClick();
    }
  };
  return (
    <div
      onClick={handleClick}
      // onClick={props.onClick}
      style={{ cursor: "pointer" }}
    >
      {props.status === "In House" ? (
        <div className="ribon-container-v2 ribon-color-inhouse">
          {inHouseLabel}
        </div>
      ) : props.status === "Aftercare" ? (
        <div className="ribon-container-v2 ribon-color-aftercare">
          Aftercare
        </div>
      ) : props.status === "Incoming" ? (
        <div className="ribon-container-v2 ribon-color-incoming">
          Incoming
        </div>
      ) : props.status === "Miracles@home" ? (
        <div className="ribon-container-v2 ribon-color-mathome">
          Miracles@home
        </div>
      ) : props.status === "Clinical Assessment" ? (
        <div className="ribon-container-v2 ribon-color-clinical-assessment">
          Clinical Assessment
        </div>
      ) : props.status === "Continued Therapy" ? (
        <div className="ribon-container-v2 ribon-color-continued-therapy">
          Continued Therapy
        </div>
      ) : props.status === "Hot Lead" ? (
        <div className="ribon-container-v2 ribon-color-hot-lead">Hot Lead</div>
      ) : props.status === "Denied Admission" ? (
        <div className="ribon-container-v2 ribon-color-denied-admission">
          Denied Admission
        </div>
      ) : props.status === "Potential" ? (
        <div className="ribon-container-v2 ribon-color-potential">
          Potential
        </div>
      ) : props.status === "Duplicate" ? (
        <div
          className="ribon-container-v2 ribon-color-duplicate"
          style={{ color: "black" }}
        >
          Duplicate
        </div>
      ) : (
        <div className="ribon-container-v2 ribon-color-inactive">Inactive</div>
      )}
    </div>
  );
}
